/* eslint-disable prettier/prettier */
// Note: this module depends on src/component/global/polyfill being loaded

// Local imports
import * as wv from '../global/worldvision.js';
import { PAGE_VARS, PageKind } from '../page/vars.js';
import { getCookie } from '../motcode_manager/index.js';
export function create_tocart_event() {
    let event = new CustomEvent('send_to_cart', {
        detail: {
            data_id: 'sponsor_data',
        },
    });
    return event;
}

// Note: There's an issue in IE where a form being submitted by ajax does
// not work. To work around it, we needed to add a hidden field at the end
// of the form. For some reason, it just needs to be there for the form to be
// successfully submitted. More info can be found here:
// https://blog.yorkxin.org/2014/02/06/ajax-with-formdata-is-broken-on-ie10-ie11.html
export function toCartTemplate(
    selectedChild,
    value,
    data_input_builder,
    datalayer_suffix = ''
) {
    let data = data_input_builder();
    let mc = '3221579';
    let sType = 'SP';
    let transaction_type = 'ODN';
    let product_code = 'REG';
    let child_variant_id = selectedChild.variant_id;
    let input_type = value === '' ? 'hidden' : 'submit';
    let value_attr = value === '' ? '' : `value="${value}"`;
    let input_cls = value === '' ? '' : 'class="button js-inject"';
    let form_action =
        PAGE_VARS.kind === PageKind.EventsApp ? 'action="/cart/add"' : '';
    let motCode = getCookie('mot_code');
    if (!motCode) {
        motCode = mc;
    }
    let template = `
        <form ${form_action} id="sponsorbtn-form"
                  method="post" enctype="multipart/form-data">
            ${data}
            <input type="hidden" name="id" value="${child_variant_id}" />
            <input type="${input_type}"
                   id="sponsor_data"
                   ${input_cls}
                   ${value_attr}
                   data-datalayer_suffix="${datalayer_suffix}"
                   data-name="${selectedChild.name}"
                   data-productId="${selectedChild.product_id}"
                   data-childId="${selectedChild.child_id}"
                   data-variant="${selectedChild.variant_id}"
                   data-country="${selectedChild.country}"
                   data-age="${selectedChild.age}"
                   data-gender="${selectedChild.gender}"
                   data-amount="${selectedChild.min_amount}" />
            <input type="hidden" name="needed_for_ie_compatibility">
            <input type="hidden" name="properties[month]" value="${selectedChild.birth_month}"/>
            <input type="hidden" name="properties[gender]" value="${selectedChild.gender}"/>
            <input type="hidden" name="properties[childnumber]" value="${selectedChild.childnumber}"/>
            <input type="hidden" name="properties[lang]" value="${selectedChild.lang}"/>
            <input type="hidden" name="properties[projectid]" value="${selectedChild.projectid}"/>
            <input type="hidden" name="properties[mc]" value="${motCode}"/>
            <input type="hidden" name="properties[childid]" value="${selectedChild.child_id}"/>
            <input type="hidden" name="properties[country]" value="${selectedChild.country.trim()}"/>
            <input type="hidden" name="properties[type]" value="${sType}"/>
            <input type="hidden" name="properties[transaction_type]" value="${transaction_type}"/>
            <input type="hidden" name="properties[firstname]" value="${selectedChild.firstname}"/>
            <input type="hidden" name="properties[product_code]" value="${product_code}"/>
            <input type="hidden" name="properties[birthday]" value="${selectedChild.birth_date}"/> 
            <input type="hidden" name="properties[age]" value="${selectedChild.age}"/> 
            
        </form>
    `;
    return template;
}
export function getDataInputs(global) {
    let urlParams = wv.get_obj(global, 'url_params') || {};
    let fields = '';

    Object.keys(urlParams).forEach(key => {
        // Ignore url params 'type' and other line-items
        let ignore = [
            'type',
            'transaction_type',
            'product_code',
            'childid',
            'projectid',
            'childnumber',
            'lang',
            'country',
        ];
        if (ignore.includes(key)) {
            return;
        }

        fields += `
            <input id="${key}Input" type="hidden"
                   name="properties[${key}]"
                   value="${urlParams[key]}" />
        `;
    });
    return fields;
}
